import { useEffect } from 'react';
import { useAppDispatch } from '../store/hooks';
import { useGetStatsQuery } from '../store/api/apiSlice';
import { setStats, setError } from '../store/slices/statsSlice';

const StatsInitializer = () => {
  const dispatch = useAppDispatch();
  const { data, error, isLoading } = useGetStatsQuery();

  useEffect(() => {
    console.log('StatsInitializer - API call status:', { data, error, isLoading });
    
    if (data) {
      console.log('Stats data received:', data);
      console.log('Dispatching setStats with data:', data);
      dispatch(setStats(data));
    } else if (error) {
      console.warn('Stats API error:', error);
      dispatch(setError(error.message || 'Failed to fetch stats'));
    }
  }, [data, error, isLoading, dispatch]);

  return null; // This component doesn't render anything
};

export default StatsInitializer;